import React, { useState, useEffect } from 'react';

const PaketList = () => {
  const [pakets, setPakets] = useState([]);

  useEffect(() => {
    fetch('https://app.bimbelstemakupang.com/api/paket-bimbel')  // API yang mengembalikan paket bimbel
      .then((response) => response.json())
      .then((data) => setPakets(data))  // Menyimpan data paket
      .catch((error) => console.error('Error fetching paket data:', error));
  }, []);

  return (
    <section className="pricing">
      <div className="container section-title">
        <h2>PAKET BIMBEL</h2>
        <div>
          <span>STEMA</span>{" "}
          <span className="description-title">KUPANG</span>
        </div>
        <div className="row justify-content-center">
          {pakets.map((paket) => (
            <div key={paket.id} className="col-md-8 mb-4">
              <div className={`pricing-item ${paket.featured ? 'featured' : ''}`}>
                {/* Layout horizontal dengan flexbox */}
                <div className="pricing-content-wrapper d-flex align-items-stretch">
                  {/* Bagian kiri - Konten teks */}
                  <div className="pricing-text-content flex-fill p-3">
                    <div className="pricing-header">
                      <h3 className="mb-3">{paket.title}</h3>
                      <p className="mb-3">{paket.description}</p>
                      <div className="price-monthly mb-3">
                        <span className="h4 text-primary">
                          Rp. {Math.floor(paket.price)?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                        </span>
                      </div>
                    </div>
                    
                    {/* Tombol Pilih Paket */}
                    <div className="pricing-footer">
                      <a 
                        href="https://wa.me/6282117519556?text=Halo,%20saya%20ingin%20bertanya%20tentang%20paket%20bimbel." 
                        className="btn btn-primary w-100"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Pilih Paket
                      </a>
                    </div>
                  </div>

                  {/* Bagian kanan - Gambar */}
                  <div className="pricing-image-wrapper flex-shrink-0">
                    <img
                      src={`https://app.bimbelstemakupang.com/storage/${paket.image}`}
                      alt={paket.title}
                      className="pricing-image h-100"
                      style={{
                        width: '500px',
                        objectFit: 'cover',
                        borderRadius: '0 8px 8px 0'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Custom CSS untuk styling tambahan */}
      <style jsx>{`
        .pricing-item {
          border-radius: 8px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          background: white;
        }

        .pricing-content-wrapper {
          min-height: 250px;
        }

        .pricing-text-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: #f8f9fa;
        }

        .pricing-image {
          transition: transform 0.3s ease;
        }

        .pricing-item:hover .pricing-image {
          transform: scale(1.02);
        }

        .pricing-item.featured {
          border: 2px solid #007bff;
        }

        .pricing-item.featured .pricing-text-content {
          background: linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%);
        }

        @media (max-width: 768px) {
          .pricing-content-wrapper {
            flex-direction: column;
          }
          
          .pricing-image-wrapper img {
            width: 100% !important;
            height: 500px;
            border-radius: 0 0 8px 8px !important;
          }
          
          .col-md-8 {
            flex: 0 0 100%;
            max-width: 100%;
          }
        }
      `}</style>
    </section>
  );
};

export default PaketList;